(function () {
  var started = false;

  function whenIdle(fn) {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(fn, { timeout: 1800 });
    } else {
      setTimeout(fn, 1);
    }
  }

  function injectScripts(urls) {
    if (!urls || !urls.length) return;
    var seen = {};
    urls.forEach(function (src) {
      if (!src || seen[src] || document.querySelector('script[src="' + src + '"]')) return;
      seen[src] = true;
      var el = document.createElement("script");
      el.src = src;
      el.defer = true;
      document.body.appendChild(el);
    });
  }

  function prefetchPages(urls) {
    if (!urls || !urls.length) return;
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn && (conn.saveData || conn.effectiveType === "slow-2g" || conn.effectiveType === "2g")) return;
    urls.forEach(function (href) {
      if (!href || document.querySelector('link[rel="prefetch"][href="' + href + '"]')) return;
      var link = document.createElement("link");
      link.rel = "prefetch";
      link.href = href;
      link.as = "document";
      document.head.appendChild(link);
    });
  }

  function collectScriptUrls(cfg) {
    var urls = (cfg.scripts || []).slice();
    document.querySelectorAll("script.ip-idle-src").forEach(function (node) {
      try {
        var src = JSON.parse(node.textContent);
        if (src) urls.push(src);
      } catch (e) {}
    });
    return urls;
  }

  function run() {
    if (started) return;
    started = true;
    whenIdle(function () {
      var cfg = { scripts: [], prefetch: [] };
      var node = document.getElementById("ip-split-load");
      if (node) {
        try {
          cfg = JSON.parse(node.textContent) || cfg;
        } catch (e) {}
      }
      injectScripts(collectScriptUrls(cfg));
      prefetchPages(cfg.prefetch);
    });
  }

  document.addEventListener("page:loaded", run);
  if (document.readyState === "complete") run();
  else setTimeout(run, 2500);
})();
